import { ORIGIN_TALL_SVG } from "../lib/shell.js";

export default function OriginMark({ className = "" }) {
  return (
    <div
      className={["w-full [&_svg]:block [&_svg]:h-auto [&_svg]:w-full", className].filter(Boolean).join(" ")}
      dangerouslySetInnerHTML={{ __html: ORIGIN_TALL_SVG }}
    />
  );
}
